export default __webpack_public_path__ + "static/shutdown-banner-web-2de64f09ead70edd002e31ae93c93b5d.png";